import { Exclude, Expose, Type } from "class-transformer";
import { IsArray, IsDefined, IsInt, IsNumber, IsUUID } from "class-validator";

import { GField, GFloat, GInputType, GInt, GObjectType } from "../graphql";

import { VehicleTypePriceFee } from "./VehicleTypePriceFee";

export interface IOrderContentLocationQueryContext {
  orderId: string;
}

@GObjectType("OrderContentLocation")
@GInputType("OrderContentLocationInput")
@Exclude()
export class OrderContentLocation {
  public queryContext?: IOrderContentLocationQueryContext;

  @GField()
  @IsUUID("4")
  @IsDefined()
  @Expose()
  public locationId: string;

  @GField(() => GInt)
  @IsInt()
  @IsDefined()
  @Expose()
  public duration: number = 60;

  @GField(() => GInt)
  @IsInt()
  @IsDefined()
  @Expose()
  public order: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public waitingPrice: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public waitingFee: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public entrancePrice: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public entranceFee: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public parkingPrice: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public parkingFee: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public tollPrice: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public tollFee: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public additionalPrice: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public additionalFee: number = 0;

  @GField(() => [VehicleTypePriceFee])
  @IsArray()
  @IsDefined()
  @Expose()
  @Type(() => VehicleTypePriceFee)
  public vehicleTypesPricesFees: VehicleTypePriceFee[] = [];
}
